import {Caller} from '../../copilot.types';

export default function appendToCallChain(
  caller: Caller | Caller[],
  callChain: Caller[],
): Caller[] {
  return Array.isArray(caller) ? [...callChain, ...caller] : [...callChain, caller];
}
